import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20teal%20abstract%20flowing%20gradient%20background%20with%20soft%20geometric%20patterns%2C%20modern%20digital%20art%20style%2C%20smooth%20curves%20and%20layered%20translucent%20shapes%2C%20cozy%20and%20inviting%20atmosphere%2C%20professional%20web%20design%20background%2C%20clean%20and%20elegant%20composition&width=1600&height=600&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2
          className="text-2xl md:text-4xl font-bold text-white mb-4"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          准备好开始你的阅读之旅了吗？
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
          立即加入百万读者的行列，在韩漫天堂发现你最喜欢的韩国漫画作品。完全免费，无需注册！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/romance"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}